import { UserInterface } from 'Interfaces'
// antd
import { Button } from 'antd'
// icons
import { LuMoreVertical } from 'react-icons/lu'
import { TbLock } from 'react-icons/tb'
import { TbCheck } from 'react-icons/tb'
import useReleaseUser from './useReleaseUser'
import authService from 'authService'

const Cell: React.FC<{ id: string; isBanned: string }> = ({ id, isBanned }) => {
  const isConsultant = authService.hasOnlyRoles(['CONSULTANTE'])
  const { onClick, isLoading } = useReleaseUser()

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end'
      }}
    >
      <Button
        loading={isLoading}
        disabled={isConsultant}
        icon={isBanned ? <TbCheck /> : <TbLock />}
        style={{
          width: 103,
          backgroundColor: isConsultant ? undefined : '#56c05a',
          color: isConsultant ? undefined : '#ffffff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around'
        }}
        onClick={() => onClick(id, isBanned ? 'unban' : 'unblock')}
      >
        {isBanned ? 'Liberar' : 'Desbloquear'}
      </Button>
    </div>
  )
}

const ReleaseUser = (id: string, record: UserInterface) => {
  const { isBanned, isBlocked } = record

  if (id === '' || !id) return null

  return <Cell id={id} isBanned={isBanned} />
}

export default ReleaseUser
